export const viLang_pt = {
  GLOBAL_LANGUAGE_NAME: 'Português',
  GLOBAL_LANGUAGE_EN: 'en-GB',
  GLOBAL_LANGUAGE_PT: 'pt-PT',

  //Common Wording
  GLOBAL_ADD: 'Adicionar',
  GLOBAL_DELETE: 'Eliminar',
  GLOBAL_UPDATE: 'Atualizar',
  GLOBAL_CONTENT: 'Conteúdo',
  GLOBAL_NEW: 'Novo',
  GLOBAL_SAVE_BUTTON: 'Guardar',
  GLOBAL_CANCEL: 'Cancelar',
  GLOBAL_RETURN_BUTTON: 'Voltar',
  GLOBAL_EQUIPMENT: 'Equipamento',
  GLOBAL_EQUIPMENTS: 'Equipamentos',
  GLOBAL_GLASSES: 'Copos',
  GLOBAL_DONATION: 'Instituições Caridade',
  GLOBAL_SECTION_TABLE_TITLE: 'Gerir',
  GLOBAL_ADD_NEW: 'Adicionar Novo',
  GLOBAL_NAME: 'Nome',
  GLOBAL_SEARCH: 'Pesquisar',
  GLOBAL_PROFILE: 'Perfil',
  GLOBAL_USERS: 'Utilizadores',
  GLOBAL_PASSWORD: 'Password',
  GLOBAL_EVENT: 'Evento',
  GLOBAL_LOGOUT: 'Sair',
  GLOBAL_ALL: 'Todas',
  GLOBAL_SHOWING: 'Mostrando',
  GLOBAL_RESULTS: 'resultados',
  GLOBAL_LANGUAGE: 'Língua',
  GLOBAL_PERIOD: 'Período',
  GLOBAL_PERIOD_STATE_CLOSED: 'Fechado',
  GLOBAL_PERIOD_STATE_OPEN: 'Aberto',
  GLOBAL_TYPE: 'Tipo',
  GLOBAL_EQUIPMENT_TYPE: 'Tipo de Equipamento',
  GLOBAL_AMOUNT: 'Montante',
  GLOBAL_QUANTITY: 'Quantidade',
  GLOBAL_QUANTITY_MIN: 'Qtd.',
  GLOBAL_NO_RESULTS: 'Sem Resultados',
  GLOBAL_CODE: 'Código',
  GLOBAL_ERROR: 'Erro',
  GLOBAL_ACCOUNT: 'Conta',
  GLOBAL_TIME: 'Tempo',
  GLOBAL_DATE: 'Data',
  GLOBAL_DATE_TIME: 'Data Hora',
  GLOBAL_DATE_TIME_CLOSE: 'Data Hora Fecho',
  GLOBAL_RECEIPT: 'Recibo',
  GLOBAL_COMISSIONS: 'Comissões (%)',
  GLOBAL_CONTRACT: 'Contrato',
  GLOBAL_ENTITY: 'Entidade',
  GLOBAL_HOURS: 'Horas',
  GLOBAL_MINUTES: 'Minutos',
  GLOBAL_STORE: 'Loja',
  GLOBAL_VAULT: 'Cofre',
  GLOBAL_BILLS: 'Notas',
  GLOBAL_BILL: 'Nota',
  GLOBAL_COINS: 'Moedas',
  GLOBAL_COIN: 'Moeda',
  GLOBAL_CURRENCY: 'Moeda',
  GLOBAL_USER_EQUIPMENTS: 'Os seus equipamentos',
  GLOBAL_PICK_A_DATE: 'Escolha uma data',
  GLOBAL_REASON: 'Motivo',
  GLOBAL_MAINTENANCE: 'Manutenção',
  GLOBAL_AGENT: 'Agente',
  GLOBAL_LICENSE: 'Licença',
  GLOBAL_STATISTICS: 'Estatísticas',
  GLOBAL_AUDITLOG: 'AuditLog',
  GLOBAL_LOCATIONS: 'Locais',
  GLOBAL_LOCATION: 'Local',
  GLOBAL_IP: 'IP',
  GLOBAL_IP_LOCAL: 'IP local',
  GLOBAL_GROUP: 'Grupo',
  GLOBAL_ENTITIES: 'Entidades',
  GLOBAL_ADDRESS: 'Morada',
  GLOBAL_LANGUAGES: 'Linguagens',
  GLOBAL_METHOD: 'Método',
  GLOBAL_ADDITIONAL_INFORMATION: 'Informação adicional',
  GLOBAL_CLEAR: 'Limpar',
  GLOBAL_DENOMINATION: ' Denominação',
  GLOBAL_DENOMINATION_MIN: ' Denom.',
  GLOBAL_INDEX: 'Índice',
  GLOBAL_VALUE: 'Valor',
  GLOBAL_WORKING_CAPITAL: 'Fundo Maneio',
  GLOBAL_WORKING_CAPITAL_MIN: 'F.M.',
  GLOBAL_TICKET: 'Ticket',
  GLOBAL_TICKETS: 'Tickets',
  GLOBAL_CLIENT: 'Cliente',
  GLOBAL_URGENCY: 'Urgência',
  GLOBAL_OTHER: ' Outro',
  GLOBAL_PRODUCT: 'Produto',
  GLOBAL_PRODUCTS: 'Produtos',
  GLOBAL_COMMENTS: 'Comentários',
  GLOBAL_ORIGIN: 'Origem',
  GLOBAL_SOLUTION: 'Solução',
  GLOBAL_GENERAL: 'Geral',
  GLOBAL_PARTICULAR: 'Particular',
  GLOBAL_IMPACT: 'Impacto',
  GLOBAL_CLASSIFICATION: 'Classificação',
  GLOBAL_CONTACT: 'Contacto',
  GLOBAL_ACCEPTED: 'Aceite',
  GLOBAL_DECLARATION: 'Declaração',
  GLOBAL_SAFE: 'Cofre',
  GLOBAL_ID_ENTITY: 'ID Entidade',
  GLOBAL_EDIT: 'Editar',
  GLOBAL_SOURCE: 'Origem',
  GLOBAL_BEFORE: 'Antes',
  GLOBAL_AFTER: 'Depois',
  GLOBAL_SYNC_COMMANDS: 'Comandos de Sincronização',
  GLOBAL_DISTRIBUITIONS: 'Distribuições',
  GLOBAL_DISTRIBUITION: 'Distribuição',
  GLOBAL_N_D: 'n/d',
  GLOBAL_DEVICES: 'Devices',
  GLOBAL_WAREHOUSE: 'Armazém',
  GLOBAL_TODAY: 'Hoje',
  GLOBAL_DAY_AGO: '1 dia atrás',
  GLOBAL_DAYS_AGO: 'dias atrás',
  GLOBAL_MINUTE_AGO: 'minuto atrás',
  GLOBAL_MINUTES_AGO: 'minutos atrás',
  GLOBAL_HOURS_AGO: 'horas atrás',
  GLOBAL_LATITUDE: 'Latitude',
  GLOBAL_LONGITUDE: 'Longitude',
  GLOBAL_COUNTRY: 'País',
  GLOBAL_OPTIONAL: 'Opcional',
  GLOBAL_ONLY_NUMERIC_VALUES: 'Apenas valores numéricos',
  GLOBAL_INVALID_INPUT: 'Entrada inválida',
  GLOBAL_CAPACITY: 'Capacidade',
  GLOBAL_MODE: 'Modo',
  GLOBAL_LIGHT: 'Modo claro',
  GLOBAL_DARK: 'Modo escuro',
  GLOBAL_OPERATION: 'Operação',
  GLOBAL_COMMAND: 'Comando',
  GLOBAL_COMMAND_ID: 'ID do Comando',
  GLOBAL_FETCH_DATA: 'A obter dados',
  GLOBAL_BALANCE: 'Saldo',
  GLOBAL_TOTAL_INVOICED: 'Total Faturado',
  GLOBAL_TOTAL_COLLECTED: 'Total Recolhido',
  GLOBAL_TOTAL_COLLECTED_PREVIOUS: 'Total Recolhido (Anterior)',
  GLOBAL_TOTAL_COLLECTED_RESPECTIVE: 'Total Recolhido (Respetivo)',
  GLOBAL_STATE: 'Estado',
  GLOBAL_ERROR_DETAILS: 'Detalhes do erro',

  //Product
  PRODUCTS_TITLE: 'Produtos',
  PRODUCT_DETAILS: 'Detalhes do Produto',
  PRODUCTS_ID: 'ID do Produto',
  PRODUCTS_PRICE: 'Preço',
  PRODUCTS_NAME: 'Nome',
  PRODUCTS_ADD: 'Adicionar produto',
  PRODUCTS_EDIT: 'Editar produto',
  PRODUCTS_ADD_SUCCESS: 'Produto adicionado',
  PRODUCTS_ADD_ERROR: 'Erro ao adicionar produto',
  PRODUCTS_DELETE_SUCCESS: 'Produto apagado',
  PRODUCTS_DELETE_ERROR: 'Não é possível apagar o produto',
  PRODUCTS_EDIT_SUCCESS: 'Produto editado',
  PRODUCTS_EDIT_ERROR: 'Erro ao editar produto',

  //Dispensers
  DISPENSERS_TITLE: ' Dispensador',
  DISPENSER_ID: 'ID do dispensador',
  DISPENSER_PRODUCT: 'Produto',
  DISPENSER_STATUS: 'Status',
  DISPENSER_QUANTITY: 'Quantidade',
  DISPENSER_NEW_QUANTITY: 'Nova quantidade',
  DISPENSERS_ADD: 'Adiconar dispensador',
  DISPENSERS_EDIT: 'Editar dispensador',
  DISPENSERS_ADD_SUCCESS: 'Dispensador adicionado',
  DISPENSERS_ADD_ERROR: 'Erro ao adicionar dispensador',
  DISPENSERS_DELETE_SUCCESS: 'Dispensador removido',
  DISPENSERS_DELETE_ERROR: 'Erro ao remover dispensador',
  DISPENSERS_EDIT_SUCCESS: 'Dispensador editado',
  DISPENSERS_EDIT_ERROR: 'Erro ao editar dispensador',

  //Periods
  PERIODS_REPORT_ERROR: 'Não foi possível obter o relatório',
  PERIODS_RECEIPT_ERROR: 'Não foi possível obter dados do recibo',
  PERIODS_RECEIPT_NO_DATA: 'Sem dados',

  // Locations
  LOCATIONS_OPEN_NEW: 'Novo local',
  LOCATIONS_OPEN_MAP: 'Abrir mapa',
  LOCATIONS_CLOSE_MAP: 'Fechar mapa',
  LOCATIONS_COUNTRY_SELECT: 'Escolha o país',
  LOCATION_NEW: 'Adicionar local',
  LOCATION_READ: 'Visualizar local',
  LOCATION_EDIT: 'Editar local',
  LOCATION_NOT_DEFINED: 'Local não definido',
  LOCATION_CHOOSE_ENTID: 'Escolha uma entidade',
  LOCATIONS_CHOOSE_LOCATION: 'Escolha locais',

  //Events Section
  EVENTS: 'Eventos',
  EVENTS_NEW: 'Adicionar Novo Evento',
  EVENT_ADDRESS: 'Endereço',
  EVENT_ZIP_CODE: 'Código Postal',
  EVENT_BEGIN_DATE: 'Data de Início',
  EVENT_BEGIN_DATE_PLACEHOLDER: 'Início',
  EVENT_END_DATE: 'Data de Fim',
  EVENT_END_DATE_PLACEHOLDER: 'Fim',
  EVENT_LAT: 'Lat',
  EVENT_LONG: 'Long',
  EVENT_ID: 'ID do Evento',
  EVENT_DATE_INFORMATION: 'Informações de Data',
  EVENT_INSTALLATION: 'Instalação',
  EVENT_UNINSTALLATION: 'Desinstalação',
  EVENT_DETAILS_GENERAL: 'Informações Gerais',
  EVENT_DETAILS_GENERAL_EVENT_DATES: 'Datas do Evento',
  EVENT_DETAILS_GENERAL_EVENT_DATES_FROM: 'De ',
  EVENT_DETAILS_GENERAL_EVENT_DATES_TO: 'até',
  EVENT_DETAILS_GENERAL_DIRECTIONS: 'Informação Geográfica',
  EVENT_GLASS_RECEPTACLE: 'Receptáculo',
  EVENT_GLASS_DELIVERY_ANIMATION: 'Animação de Entrega',
  EVENT_AD_ORDER: 'Ordem',
  EVENT_ID_PLACEHOLDER: 'Introduza ID do Evento',
  EVENT_NAME_PLACEHOLDER: 'Introduza Nome do Evento',
  EVENT_ZIP_CODE_PLACEHOLDER: '0000-000 Cidade',
  EVENT_LAT_PLACEHOLDER: '0.000',
  EVENT_LONG_PLACEHOLDER: '0.000',
  EVENT_EQUIPMENT_FORM_TITLE: 'Adicionar Equipamento ao Evento',
  EVENT_EQUIPMENT_FORM_SELECT: 'Selecione o Equipamento',
  EVENT_GLASS_FORM_TITLE: 'Adicionar Copo ao Evento',
  EVENT_GLASS_FORM_GLAS: 'Selecione o Copo',
  EVENT_GLASS_FORM_SELECT_RECEPTACLE: 'Selectione o Receptáculo',
  EVENT_GLASS_FORM_RECEPTACLE_1: 'Receptáculo 1',
  EVENT_GLASS_FORM_RECEPTACLE_2: 'Receptáculo 2',
  EVENT_GLASS_FORM_DELIVERY: 'Selecione a Animação de Entrega',
  EVENT_GLASS_FORM_RIGHT: 'Direccionar para a direita',
  EVENT_GLASS_FORM_LEFT: 'Direccionar para a esquerda',
  EVENT_AD_FORM_TITLE: 'Adicionar Anúncio ao Evento',
  EVENT_AD_FORM_SELECT: 'Selecione o Anúncio',
  EVENT_AD_FORM_ORDER: 'Escolha a ordem',
  EVENT_DON_FORM_TITLE: 'Adicionar Instituição de Caridade ao Evento',
  EVENT_DON_SELECT: 'Selecione a Instituição de Caridade',
  EVENT_CODE: 'Código do evento',
  EVENT_DATE: 'Data do evento',
  EVENT_LOG: 'Event log',
  EVENT_LOG_CONSULT: 'Consultar event log',
  EVENT_ADD_EVENT: 'Adicionar evento',
  EVENT_HELPDESK_DESTDESISOR: 'Decisor de Destino',
  EVENT_HELPDESK_DESTDISPACTER: 'Despachante de Destino',
  EVENT_HELPDESK_DESTDISTRIBUTIONLIST: 'Lista de Distribuição',
  EVENT_HELPDESK_DESTMONITOR: 'Monitor',
  EVENT_ACTUATION: 'Actuação',
  EVENT_MANAGEMENT: 'Gestão de eventos',
  ADD_EVENT_SUCCESS: 'Evento adicionado',
  ADD_EVENT_ERROR: 'Erro ao adicionar o evento',
  EDIT_EVENT_SUCCESS: 'Evento atualizado',
  EDIT_EVENT_ERROR: 'Erro ao atualizar o evento',
  DELETE_EVENT_SUCCESS: 'Evento eliminado',
  DELETE_EVENT_ERROR: 'Erro ao eliminar o evento',

  // Delegation Section
  LOCATION_ADD_ALERT_SUCCESS: 'Local adicionado',
  LOCATION_UPDATE_ALERT_SUCCESS: 'Local editado',
  LOCATION_ADD_ALERT_ERROR: 'Erro ao adicionar local',
  LOCATION_UPDATE_ALERT_ERROR: 'Erro ao atualizar local',
  LOCATION_DELETE_ALERT_SUCCESS: 'Local apagado',
  LOCATION_DELETE_ALERT_ERROR: 'Erro ao apagar local',
  LOCATION_DOES_NOT_EXIST: 'Local não existe',

  //Equipment Section
  EQUIPMENT_ID: 'ID do Equipamento',
  EQUIPMENT_ID_MIN: 'EID',
  EQUIPMENT_SERIAL_NUMBER: 'Nr. de Série',
  EQUIPMENT_DESCRIPTION: 'Descrição',
  EQUIPMENT_IDENTIFICATION: 'Identificação',
  EQUIPMENT_SOFTWARE_VERSION: 'Versão de Software',
  EQUIPMENT_SOFTWARE_VERSION_MIN: 'Versão de Soft.',
  EQUIPMENT_CYCLE: 'Ciclo',
  EQUIPMENT_OCCUPATION: 'Ocupação',
  EQUIPMENT_COM_STATE: 'Estado',
  EQUIPMENT_STATE: 'Estado Equipamento',
  EQUIPMENT_STATE_MIN: 'Est. Equip.',
  EQUIPMENT_COM_DATE: 'Última Comunicação',
  EQUIPMENT_LAST_COM_DT: 'Data Última Comunicação',
  EQUIPMENT_COM_DATE_MIN: 'Últ. Com.',
  EQUIPMENT_LAST_OPER: 'Última Operação',
  EQUIPMENT_LAST_OPER_MIN: 'Últ. Oper.',
  EQUIPMENT_LAST_OPER_DT: 'Data Última Operação',
  EQUIPMENT_LAST_OPER_DT_MIN: 'DT Últ. Oper.',
  EQUIPMENT_OCCUPATION_PER: '% Ocupação',
  EQUIPMENT_LOCAL: 'Local',
  EQUIPMENT_DETAILS_TITLE: 'Detalhes do Equipamento',
  EQUIPMENT_DETAILS_SUBTITLE: 'Informações do Equipamento',
  EQUIPMENT_ID_PLACEHOLDER: 'Por favor introduza o ID do Equipamento',
  EQUIPMENT_FORM_TITLE: 'Adicionar Novo Equipamento',
  EQUIPMENT_EDIT: 'Editar equipamento',
  EQUIPMENT_AUTOMATIC_CLOSE: 'Hora de fecho automático',
  EQUIPMENT_TOTAL_AMOUNT: 'Total no Equipamento',
  EQUIPMENT_TOTAL_AMOUNT_MIN: 'Total no Equip.',
  EQUIPMENT_BILLS_RECYCLE: 'Reciclador de notas',
  EQUIPMENT_COINS_RECYCLE: 'Reciclador de moedas',
  EQUIPMENT_STATE_OK: 'Ok',
  EQUIPMENT_STATE_INACTIVE: 'Inativa',
  EQUIPMENT_STATE_PICKUP: 'É necessário recolha',
  EQUIPMENT_STATE_CHARGE: 'É necessário recarregamento',
  EQUIPMENT_STATE_ERROR: 'Algum dispositivo em erro',
  EQUIPMENT_LIMIT_MAX: 'Limite máximo atingido',
  EQUIPMENT_LIMIT_PICKUP: 'Limite de recolha atingido',
  EQUIPMENT_LIMIT_MIN: 'Limite mínimo atingido',
  EQUIPMENT_REGISTER: 'Registar Equipamento',
  EQUIPMENT_CONTRACT: 'Consultar contracto',
  EQUIPMENT_NO_CONTRACT: 'Equipamento sem contrato associado',
  EQUIPMENT_CONSULT: 'Consultar equipamento',
  EQUIPMENT_CREATE_TICKET: 'Criar ticket',
  EQUIPMENT_CONSULT_TICKET: 'Consultar ticket',
  EQUIPMENT_AUTHORIZE_INITIATION: 'Autorizar inicialização',
  EQUIPMENT_REASONS_DECLARATIONS: 'Razões e Declarações',
  EQUIPMENT_ADD_NEW_REASON: 'Adicionar novo motivo',
  EQUIPMENT_ADD_NEW_DECLARATION: 'Adicionar nova declaração',
  EQUIPMENT_UPDATE_REASON: 'Editar motivo',
  EQUIPMENT_UPDATE_DECLARATION: 'Editar declaração',
  EQUIPMENT_LOCAL_IP: 'IP do local',
  EQUIPMENT_MAX_COINS_SAFE: 'Máximo de moedas no cofre',
  EQUIPMENT_MAX_BILLS_SAFE: 'Máximo de notas no cofre',
  EQUIPMENT_ALMOST_FULL_SAFE: '% cofre quase cheio',
  EQUIPMENT_FULL_SAFE: '% cofre cheio',
  EQUIPMENT_CARD_INSERTION_TIME: 'Tempo limite para inserir cartão',
  EQUIPMENT_CARD_REMOVAL_TIME: 'Tempo limite para remover cartão',
  EQUIPMENT_DATA_INSERTION_TIME: 'Tempo limite para inserção de dados',
  EQUIPMENT_DEPOSIT_INSERTION_TIME: 'Tempo limite para depositar',
  EQUIPMENT_DECLARATION_TIME: 'Tempo limite para selecionar declaração',
  EQUIPMENT_AMOUNT_CURRENCY: 'Conversão do valor dentro do cofre',
  EQUIPMENT_ALMOST_FULL_AMOUNT: 'Montante para cofre quase cheio',
  EQUIPMENT_FULL_AMOUNT: 'Montante para cofre cheio',
  EQUIPMENT_EXISTENCE_RECYCLER: 'Exist. em Reciclagem',
  EQUIPMENT_WC_SURPLUS: 'F.M. Excedente',
  EQUIPMENT_WC_LACKING: 'F.M. em Falta',
  EQUIPMENT_EXISTENCE_SAFE: 'Exist. em Cofre',
  EQUIPMENT_TOTAL_EXISTENCE: 'Total Existências',
  EQUIPMENT_CONSULT_WORKING_CAPITAL: 'Consultar existências e fundo de maneio',
  EQUIPMENT_CONSULT_DISPENSERS: 'Consultar dispensadores',
  EQUIPMENT_EDIT_DISPENSERS: 'Editar dispensadores',
  EQUIPMENT_EDIT_WORKING_CAPITAL: 'Editar config. moeda/fundo maneio',
  EQUIPMENT_FILL_EXISTENCE_WORKING_CAPITAL: 'Preencher F.M. com existências',
  EQUIPMENT_CLEAR_WORKING_CAPITAL: 'Limpar fundo maneio',
  EQUIPMENT_UPDATE_WC_SUCCESS: 'Fundo de maneio actualizado',
  EQUIPMENT_UPDATE_WC_ERROR: 'Erro ao actualizar fundo de maneio',
  EQUIPMENT_COUNTRY_SELECT: 'Selecione o país',
  EQUIPMENT_CURRENCY_SELECT: 'Selecione a moeda',
  EQUIPMENT_ADD_SUCCESS: 'Equipamento adicionado',
  EQUIPMENT_ADD_ERROR: 'Erro ao adicionar equipamento',
  EQUIPMENT_MAX_CURRENCIES: 'Nº máximo de moedas',

  //Equipment Status Label
  EQUIPMENT_STATUS_LABEL_NOT_DEFINED: 'Não Definido',
  EQUIPMENT_STATUS_LABEL_DEFINED: 'Definido',
  EQUIPMENT_STATUS_LABEL_INICIALIZED: 'Inicializado',
  EQUIPMENT_STATUS_LABEL_ONLINE: 'Online',
  EQUIPMENT_STATUS_LABEL_OFFLINE: 'Offline',
  EQUIPMENT_STATUS_IN_SERVICE_WITH_WARN: 'Em serviço com avisos',
  EQUIPMENT_STATE_BUTTON_IN_SERVICE: 'Em serviço',
  EQUIPMENT_STATE_BUTTON_OUT_OF_SERVICE: 'Fora de serviço',
  EQUIPMENT_STATE_LABEL_OUT_OF_SERVICE_FAKE_NOTE: 'Fora de Serviço com notas suspeitas retidas',
  EQUIPMENT_STATE_LABEL_TITLE: 'Estado de Equipamento',
  EQUIPMENT_STATE_LABEL_PRINTER: 'Impressora',
  EQUIPMENT_STATE_LABEL_CARD_READER: 'Leitor de cartões',
  EQUIPMENT_STATE_LABEL_RFID_READER: 'Leitor RFID',
  EQUIPMENT_STATE_LABEL_UPS: 'UPS',
  EQUIPMENT_STATE_LABEL_PAY_SYSTEM: 'Sistema de pagamento',
  EQUIPMENT_STATE_LABEL_MANUAL_STATE: 'Estado manual',
  EQUIPMENT_STATE_LABEL_QUANTITY: 'Quantidade',
  EQUIPMENT_STATE_LABEL_MAX_AMOUNT: 'Montante máximo',
  EQUIPMENT_STATE_LABEL_MIN_AMOUNT: 'Montante mínimo',
  EQUIPMENT_STATE_LABEL_DEC_AMOUNT: 'Montante  para declarado',
  EQUIPMENT_STATE_BUTTON_RESTART: 'Reiniciar  ',
  EQUIPMENT_STATE_BUTTON_SHUTDOWN: 'Desligar',
  EQUIPMENT_STATE_BUTTON_OPEN_ESCROW: 'Abrir escrow',
  EQUIPMENT_STATE_BUTTON_CLOSE_ESCROW: 'Fechar escrow',
  EQUIPMENT_NO_INFORMATION: 'Sem informação disponível',
  EQUIPMENT_NO_DATA: 'Sem dados disponíveis',
  EQUIPMENT_NO_STATUS: 'Sem status',
  S_LEFT_DOOR_LABEL: 'Porta esquerda',
  S_RIGTH_DOOR_LABEL: 'Porta direita',
  S_MAINT_STRUCTURE_LABEL: 'Estrutura de manutenção',
  S_SAFE_DOOR_LABEL: 'Porta do cofre',
  S_SAFE_DOOR_LOCK_LABEL: 'Fechadura da porta do cofre',
  S_BAG_LABEL: 'Saco',
  S_ESCROW_LABEL: 'Escrow',
  S_ESCROW_MONEY_INSIDE_LABEL: 'Notas no escrow',
  S_COINS_DOOR_LABEL: 'Porta das moedas',
  S_COINS_DOOR_LOCK_LABEL: 'Tranca porta das moedas',
  S_PROCESSOR_DRAWER_LABEL: 'Gaveta do processamento',
  S_BILLS_DOOR_LABEL: 'Porta das notas',
  S_BILLS_DOOR_LOCK_LABEL: 'Tranca porta das notas',
  S_COINS_DRAWER_LABEL: 'Gaveta de moedas',
  S_COINS_SAFE_LABEL: 'Cofre das moedas',
  EQUIPMENT_STATE_IN_SERVICE_WITH_ALERTS: 'Em serviço com alertas',
  EQUIPMENT_SAFE_OCC_PERC: 'Ocupação Cofre (%)',
  EQUIPMENT_SAFE_OCC_PERC_MIN: '% Ocup. Cofre',

  //Equipment Status
  OK: 'Ok',
  YES: 'Sim',
  NO: 'Não',
  IN_ERROR: 'Em erro',
  NO_PAPER: 'Sem papel',
  CARD_INSIDE: 'Cartão no leitor',
  LOW_PAPER: 'Pouco papel',
  OUT_OF_SERVICE: 'Fora de serviço',
  FULL: 'Cheio',
  NEAR_FULL: 'Quase cheio',
  OPEN: 'Aberto',
  CLOSE: 'Fechado',
  LOCKED: 'Trancado',
  UNLOCKED: 'Destrancado',
  NOT_INSTALLED: 'Não instalado',
  VALIDATOR_IN_ERROR: 'Validador(es) em erro',
  UPS_ON_BATTERY: 'UPS em bateria',
  EDIT_EQUIPMENTS_ALERT_UPDATED_SUCCESS: 'Equipamento editado',
  EDIT_EQUIPMENTS_ALERT_UPDATED_ERROR: 'Erro ao editar equipamento',

  EQUIPMENT_STATE_LABEL_COIN_VALIDATOR: 'Estado validador de moedas',
  EQUIPMENT_STATE_LABEL_BILL_VALIDATOR: 'Estado validador de notas',
  EQUIPMENT_STATE_LABEL_COIN_SAFE: 'Estado cofre moedas',
  EQUIPMENT_STATE_LABEL_BILL_SAFE: 'Estado cofre notas',
  EQUIPMENT_STATE_LABEL_COIN_RECYCLER: 'Estado reciclador de moedas',
  EQUIPMENT_STATE_LABEL_BILL_RECYCLER: 'Estado reciclador de notas',
  EQUIPMENT_STATE_LABEL_AUTOMATIC_PAYMENT: 'Pagamento automático',
  EQUIPMENT_STATE_LABEL_PRODUCT_DISPENSER: 'Dispensador de produto',

  REMOVE_REASON: 'Tem a certeza que pretende apagar este motivo?',
  REMOVE_DECLARATION: 'Tem a certeza que pretende apagar esta declaração?',
  ADD_REASON_SUCCESS: 'Motivo adicionado',
  ADD_DECLARATION_SUCCESS: 'Declaração adicionada',
  ADD_REASON_ERROR: 'Erro ao adicionar motivo',
  ADD_DECLARATION_ERROR: 'Erro ao adicionar declaração',
  UPDATE_REASON_SUCCESS: 'Motivo actualizado',
  UPDATE_DECLARATION_SUCCESS: 'Declaração actualizada',
  UPDATE_REASON_ERROR: 'Erro ao actualizar motivo',
  UPDATE_DECLARATION_ERROR: 'Erro ao actualizar declaração',
  REMOVE_REASON_SUCCESS: 'Motivo removido',
  REMOVE_DECLARATION_SUCCESS: 'Declaração removida',
  REMOVE_REASON_ERROR: 'Erro ao remover motivo',
  REMOVE_DECLARATION_ERROR: 'Erro ao remover declaração',
  EQUIPMENT_AUTHORIZE_INITIALIZATION_SUCCESS: 'Inicialização autorizada',
  EQUIPMENT_AUTHORIZE_INITIALIZATION_ERROR: 'Falha ao autorizar a inicialização',

  // Deposit equipments transactions
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EID: 'EID',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EQUIPMENT_TYPE: 'Tipo',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_BANK: 'Banco',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_BRANCH: 'Delegação',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_STATUS: 'Estado',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_EQUIPMENT_STATE: 'Est. Equip.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_DATE_LAST_COMMUNICATION: 'Última com.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_OPERATION: 'Últ. oper.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_OPERATION_DATE: 'DT últ. oper.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_PERIOD: 'Período',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_LAST_CASH_BALANCE: 'Montante',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_LABEL_SOFTWARE_VERSION: 'Versão de Soft.',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_ALERT_COMMAND: 'Comando enviado',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_ALERT_SELECT_FILE: 'Por favor, selecione um ficheiro!',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_BUTTON_ALL_IN_SERVICE: 'Todos em serviço',
  DEPOSIT_EQUIPMENTS_TRANSACTIONS_BUTTON_ALL_OUT_OF_SERVICE: 'Todos fora de serviço',

  //Equipment agreeType
  AGREE_STATE_0: 'n/d',
  AGREE_STATE_1: 'Ativo',
  AGREE_STATE_2: 'Suspenso',
  AGREE_STATE_3: 'Cancelado',
  AGREE_STATE_4: 'Incumprimento',

  //Glass Section
  GLASS: 'Copo',
  GLASS_NEW: 'Adicionar Novo Copo',
  GLASS_IMAGE: 'Imagem',
  GLASS_DESCRIPTION: 'Descrição',
  GLASS_DETAILS_TITLE: 'Detalhes do Copo',
  GLASS_ID: 'ID do Copo',
  GLASS_ID_PLACEHOLDER: 'Introduza ID do Copo',
  GLASS_CODE: 'Código',
  GLASS_CODE_PLACEHOLDER: 'Introduza o código',
  GLASS_SELECT_IMAGE: 'Selecione uma imagem',
  GLASS_DESCRIPTION_PLACEHOLDER: 'Descrição do copo',
  GLASS_SIZE_TYPE: 'Categoria de Tamanho',
  GLASS_SIZE_TYPE_PLACEHOLDER: 'Categoria de tamanho',
  GLASS_READ: 'Ler Copo',

  //Glass Category
  CATEGORY: 'Categoria',
  CATEGORIES: 'Categorias',
  CATEGORY_DESCRIPTION: 'Descrição',
  CATEGORY_NEW: 'Nova Categoria',

  //Advertising Section
  ADVERTISEMENTS: 'Anúncios',
  ADVERTISING_NEW: 'Adicionar Novo Anúncio',
  ADVERTISING_FILE: 'Ficheiro',
  ADVERTISING_DURATION: 'Duração',
  ADVERTISING_SECONDS: 'segundos',
  ADVERTISING_SECS: 'segs',
  ADVERTISING_DETAILS_TITLE: 'Detalhes do Anúncio',
  ADVERTISING: 'Anúncio',
  ADVERTISING_ID: 'ID do Anúncio',
  ADVERTISING_ID_PLACEHOLDER: 'Introduza ID do Anúncio',

  //Donation Entities Section
  DONATION_ENTITY: 'Instituição',
  DONATION_ENTITIES: 'Instituições',
  DONATION_ENTITIES_LOGO: 'Logo',
  DONATION_ENTITY_ID: 'Id da Instituição',
  DONATION_ENTITY_ID_PLACEHOLDER: 'Introduza o Id da Instituição',
  DONATION_ENTITY_NAME_PLACEHOLDER: 'Introduza o nome da Instituição',
  DONATION_ENTITY_SELECT_LOGO: 'Selecione o logo',
  DONATION_ENTITY_FORM_TITLE: 'Adicionar Nova Insituição',

  //Login
  LOGIN_ENTITY: 'Entidade',
  LOGIN_USER: 'Utilizador',
  LOGIN_BUTTON: 'Entrar',
  LOGIN_EMAIL: 'Entrar com e-mail',
  LOGIN_USERID: 'Entrar com UserID',

  //Alert
  ALERT_ERROR_CODE: 'Código',
  ALERT_ERROR_MESSAGE: 'Mensagem',

  //Users
  USER_UID: 'ID Utilizador',
  USER_EMAIL: 'Email',
  USER_EMAIL_PLACEHOLDER: 'exemplo@email.com',
  USER_CARD: 'Cartão',
  USER_CARD_PLACEHOLDER: 'Indique cartão ',
  USER_REGION: 'Região',
  USER_LANG: 'Idioma',
  USER_LANG_EN: 'Inglês',
  USER_LANG_PT: 'Português',
  USER_NEW: 'Adicionar Novo Utilizador',
  USER_ENTITY: 'Entidade',
  USER_ENTITY_PLACEHOLDER: 'Selecione a Entidade',
  USER_ID: 'ID do Utilizador',
  USER_ID_PLACEHOLDER: 'Selecione o ID ',
  USER_NAME_PLACEHOLDER: 'Indique o nome ',
  USER_MOBILE: 'Telemóvel',
  USER_PHONE: 'Telefone',
  USER_MOBILE_PLACEHOLDER: 'Indique o número de telefone ',
  USER_PERMISSIONS: 'Permissões',
  USER_CONFIRM_PASSWORD: 'Confirmar Password',
  USER_CONFIRM_CURRENT_PASSWORD: 'Confirme a sua Password atual',
  USER_CHANGE_PASSWORD: 'Alterar Password',
  USER_NEW_PASSWORD: 'Nova Password',
  USER_NEW_PASSWORD_ERROR: 'Passwords devem ser iguais',
  USER_PIN: 'Código PIN',
  USER_CHANGE_PIN: 'Alterar PIN',
  USER_NEW_PIN: 'Novo PIN',
  USER_CONFIRM_PIN: 'Confirmar Código PIN',
  USER_NEW_PIN_ERROR: 'Pins devem ser iguais',
  USER_DELETE_CONFIRM: 'Tem a certeza que pretende eliminar este utilizador? Esta ação é irreversível',
  USER_CONTACT_INFO: 'Contactos',
   USER_IMPORT_CSV_FILE:'Importar',
   USER_IMPORT_SUCCESS:'Ficheiro importado',
USER_IMPORT_ERROR:'Erro ao importar ficheiro',
  ADD_USER_ALERT_UPDATE_SUCCESS: 'Utilizador criado',
  ADD_USER_ALERT_UPDATE_ERROR: 'Erro ao criar utilizador, verifique os campos e tente novamente',
  EDIT_USER_ALERT_UPDATE_SUCCESS: 'Utilizador atualizado',
  EDIT_USER_ALERT_UPDATE_ERROR: 'Erro ao atualizar utilizador',
  EDIT_USER_ALERT_DELETE_ERROR: 'Erro ao eliminar utilizador',
  EDIT_USER_ALERT_UPDATE__PASSWORD_ERROR: 'Password inválida',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_1: 'Gestão de utilizadores e permissões',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_2: 'Configurações de sistema',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_3: 'Operações remotas não financeiras a equipamentos',
  EDIT_USERS_LABEL_SYSTEM_MANAGEMENT_PERMISSION_4: 'Técnico',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_1: 'Dados financeiros',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_2: 'CIT',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_3: 'Operações remotas financeiras a equipamentos',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_4: 'Operador',
  EDIT_USERS_LABEL_BUSINESS_DATA_MANAGEMENT_PERMISSION_5: 'APM',

  //app4
  APP4_OPT0: 'Gestão Contratos',
  APP4_OPT1: 'Gestão Clientes',
  APP4_OPT3: 'Helpdesk',
  APP4_OPT5: 'Gestão eventos & Contadores',

  //app5
  APP5_OPT0: 'Gestão de produtos',
  APP5_OPT1: 'Gestão de produções',
  APP5_OPT2: 'Receção de produtos',

  //app100
  APP100_OPT0: 'Relatórios financeiros',
  APP100_OPT1: 'Stock',
  APP100_OPT2: 'Documentos',
  USER_DELEGATIONS: 'Delegações',
  USER_DELEGATION: 'Delegação',
  USER_MY_PROFILE: 'O meu Perfil',
  USER_PROFILE: 'Perfil',

  //Movements
  PROCESSED_GLASS_PERIOD: 'Período',
  PROCESSED_GLASS_ID: 'ID',
  PROCESSED_GLASS_STATUS: 'Estado',
  SUCCESS: 'Recolhido',
  CANCELLED: 'Cancelado',
  ERROR: 'Erro',
  PROCESSED_GLASS_ERROR: 'Erro',
  NONE: ' ',
  INTERNAL: 'Erro Interno',
  NO_GLASS_ID: 'Copo Não Reconhecido',
  PROCESSED_GLASS_REFUND_TYPE: 'Tipo Devolução',
  CASH: 'Numerário',
  MULTIBANCO: 'Cartão (MB)',
  DONATION: 'Doação',
  PROCESSED_GLASS_TUBE: 'Tubo',
  PROCESSED_GLASS_INITIAL_DATE: 'Data Inicial',
  PROCESSED_GLASS_END_DATE: 'Data Final',
  PROCESSED_GLASS_SEARCH_PLACEHOLER: 'Seleccione uma opção',

  //Transactions
  TRANSACTIONS: 'Transações',
  TRANSACTION: 'Transação',
  TRANSACTION_ID: 'ID da Transação',
  TRANSACTION_DETAILS: 'Detalhes da Transação',
  TRANSACTION_RECEIVED: 'Recebido',
  TRANSACTION_DISPENSED: 'Dispensado',
  TRANSACTION_PAYMENT_METHOD: 'Método de Pagamento',
  TRANSACTION_USER_CASHIER: 'Utilizador/Caixa',
  TRANSACTION_DEPOSITOR: 'Depositante',
  TRANSACTION_EXTERNAL_ID: 'ID Externo',
  TRANSACTION_NUMBER: 'Nº Transação',
  TRANSACTION_NUMBERS: 'Nº Transações',
  TRANSACTION_NUMBERS_FULL: 'Número de Transações',
  TRANSACTION_AMOUNT_CHARGED: 'Montante Cobrado',
  TRANSACTION_COMISSION_AMOUNT: 'Montante Comissão',
  TRANSACTION_AMOUNT_CREDITED: 'Montante Creditado',
  TRANSACTION_REJECTED: 'Rejeitada',
  TRANSACTION_SUSPECT: 'Suspeita',
  TRANSACTION_NOTE_SN: 'N.S. Nota',
  TRANSACTION_INITIAL_DATE: 'Data inicial',
  TRANSACTION_END_DATE: 'Data final',
  TRANSACTION_BANKING_DETAILS: 'Dados bancários',
  TRANSACTION_NO_LOG: 'Nenhuma transação selecionada',
  TRANSACTION_LOG_SUCCESS: 'Log obtido',
  TRANSACTION_LOG_ERROR: 'Log não disponível',
  TRANSACTION_LOG_NO_DATA: 'Nenhum dado disponível para esta transação',
  TRANSACTION_LOG_MISSING_PARAMS: 'Parâmetros de transação ausentes',
  TRANSACTION_DOC: 'Documento',
  TRANSACTION_FINANCIAL_ONLY: 'Só financeiras',
  TRANSACTION_TYPE: 'Tipo de Transação',
  TRANSACTION_TYPE_FT: 'FT',
  TRANSACTION_TYPE_TX: 'TX',
  TRANSACTION_REPORT_ERROR: 'Erro ao obter o relatório',

  CASH_COLLECTIONS: 'Recolhas de numerário',
  CASH_COLLECTION_DETAIL: 'Detalhe da Recolha de Numerário',
  CASH_COLLECTION_EXCESS: 'Excesso',
  CASH_COLLECTION_CUMULATIVE_EXCESS: 'Excesso acumulado',
  CASH_COLLECTION_CUMULATIVE_EXCESS_PREVIOUS: 'Excesso acumulado anterior',
  CASH_COLLECTION_WORKING_CAPITAL_EXCESS_REMOVED_SHORT: 'F.M. Exc. Rem.',
  CASH_COLLECTION_WORKING_CAPITAL_EXCESS_REMOVED: 'Fundo de Maneio em excesso removido',
  CASH_COLLECTION_TOTAL_LOADED: 'Total de carregamentos',
  CASH_COLLECTION_FIRST_PERIOD_OPEN_DATE: 'Data de abertura do primeiro período',
  CASH_COLLECTION_LAST_PERIOD_CLOSE_DATE: 'Data de fecho do último período',

  //Transactions type:
  TRANSACTION_TYPE_CASH: 'Numerário',
  TRANSACTION_TYPES_MULTIBANCO: 'Cartão (MB)',

  //Currency Table
  CURRENCY_TABLE_CASH_IN: 'Detalhes de Entrada',
  CURRENCY_TABLE_CASH_OUT: 'Detalhes de Saída',
  CURRENCY_TABLE_READING: 'Detalhe da leitura',

  //Enterprise Equipment Periods
  ENTERPRISE_PERIOD: 'Período',
  ENTERPRISE_EQUIP_PERIODS: 'Períodos',
  ENTERPRISE_EQUIP_PERIODS_SHORT: 'Períodos Equip.',
  ENTERPRISE_EQUIP_PERIODS_DT_OPEN: 'Data/Hora abertura',
  ENTERPRISE_EQUIP_PERIODS_DT_CLOSE: 'Data/Hora fecho',
  ENTERPRISE_EQUIP_PERIODS_USER_OPEN: 'Utilizador abertura',
  ENTERPRISE_EQUIP_PERIODS_USER_CLOSE: 'Utilizador fecho',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_AMOUNTS: 'Montante Pagamentos',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_AMOUNTS_MIN: 'Mont. Pagamentos',
  ENTERPRISE_EQUIP_PERIODS_PAYMENT_CLOSE_CODE: 'Código (fecho)',
  PERIOD_TOTAL_AMOUNT: 'Montante total recebido',
  PERIOD_TOTAL_PAID: 'Montante em pagamentos',
  PERIOD_TOTAL_PAID_CASH: 'Montante pagamentos em numerário',
  PERIOD_TOTAL_PAID_CARD: 'Montante pagamentos em cartão (MB)',

  //Bank Transactions
  BANK_TRANSACTIONS: 'Transações Bancárias',

  //Dashboard
  DASHBOARD: 'Dashboard',
  DASHBOARD_EQUIPMENT_LIST: 'Estado dos Equipamentos',
  DASHBOARD_CURRENT_PERIOD: 'Período corrente',
  DASHBORAD_ENTITY: 'Resumo Equipamentos Instalados',
  DASHBOARD_OCCUPANCY: 'Ocup(%)',
  DASHBOARD_LAST_TRANSACTION: 'Última Transação',
  DASHBOARD_LAST_TRANSACTION_SHORT: 'Últ. Trans.',
  DASHBOARD_ALMOST_FULL: 'Quase cheias',
  DASHBOARD_FULL: 'Cheias',
  DASHBOARD_EMPTY: 'Vazio',
  DASHBOARD_LAST_OPERATIONS: 'Últimas Operações',
  DASHBOARD_FULL_AMOUNT: 'Montante Total',
  DASHBOARD_RECEIVED_TODAY: 'Recebido Hoje',
  DASHBOARD_ALL_EQUIPMENTS: 'Todos os Equipamentos',
  DASHBOARD_MAX_LAST_DAYS: '(Max. últim. 7 dias)',
  DASHBOARD_AMOUNT_PER_DAY: 'Montante por Dia',
  DASHBOARD_AMOUNT_PER_DAY_EURO: 'Montante por Dia (€)',
  DASHBOARD_AVG_7_DAYS: 'Média 7 Dias',
  DASHBOARD_AVG_PREV_WEEK: 'Média Semana Ant.',
  DASHBOARD_AVG_30_DAYS: 'Média 30 Dias',
  DASHBOARD_AVG_PREV_MONTH: 'Média Mês Ant.',
  DASHBOARD_PERIOD_OPEN_DATE: 'Data Abertura Período',
  DASHBOARD_PERIOD_CLOSE_DATE: 'Data Fecho Período',
  DASHOBOARD_PERIOD_TOTAL_EQUIPMENT: 'Total no Equipamento',
  DASHBOARD_PERIOD_MONEY_PAY: 'Pagamentos em Numerário',
  DASHBOARD_PERIOD_CARD_PAY: 'Pagamentos em Cartão (MB)',
  DASHBOARD_PERIOD_NUMBER: 'Nº',
  DASHBOARD_PERIOD_DISPENSER_PRODUCT_NAME: 'Nome do produto',
  DASHBOARD_PERIOD_DISPENSER_STATUS: 'Estado',
  DASHBOARD_EQUIPMENT_PRODUCT_DISPENSERS: 'Dispensadores',

  //Payment methods
  VALUE_TYPE_CASH: 'Numerário',
  VALUE_TYPE_MULTIBANCO: 'Cartão (MB)',

  // Transactions type
  OP_01010101_LABEL: 'Pagamento',
  OP_01010101_LABEL_MIN: 'Pagamento',
  OP_01010122_LABEL: 'Pagamento Cancelado',
  OP_01010122_LABEL_MIN: 'P. Cancelado',
  OP_01010123_LABEL: 'Pagamento Recuperado',
  OP_01010123_LABEL_MIN: 'P. Recuperado',
  OP_01010125_LABEL: 'Pagamento Rejeitado',
  OP_01010125_LABEL_MIN: 'P. Rejeitado',
  OP_01010128_LABEL: 'Pagamento Rejeitado por erro',
  OP_01010128_LABEL_MIN: 'P.Rej. por erro',
  OP_01010201_LABEL: 'Depósito',
  OP_01010201_LABEL_MIN: 'Depósito',
  OP_01010202_LABEL: 'Depósito por tempo esgotado',
  OP_01010202_LABEL_MIN: 'Depósito',
  OP_01010222_LABEL: 'Depósito cancelado',
  OP_01010222_LABEL_MIN: 'D. cancelado',
  OP_01010223_LABEL: 'Depósito recuperado',
  OP_01010223_LABEL_MIN: 'D. recuperado',
  OP_01010224_LABEL: 'Depósito cancelado por tempo esgotado',
  OP_01010224_LABEL_MIN: 'D. cancelado',
  OP_01010225_LABEL: 'Depósito rejeitado',
  OP_01010225_LABEL_MIN: 'D. cancelado',
  OP_01010226_LABEL: 'Depósito rejeitado com dinheiro com tempo esgotado',
  OP_01010226_LABEL_MIN: 'D. rejeitado',
  OP_01010227_LABEL: 'Depósito com erro rejeitado por tempo esgotado',
  OP_01010227_LABEL_MIN: 'D. rejeitado',
  OP_01010228_LABEL: 'Depósito com erro rejeitado',
  OP_01010228_LABEL_MIN: 'D. rejeitado',
  OP_01010229_LABEL: 'Depósito com erro rejeitado com dinheiro com tempo esgotado',
  OP_01010229_LABEL_MIN: 'D. rejeitado',
  OP_01010230_LABEL: 'Transação cancelada por falta de resposta, necessita revisão manual',
  OP_01010230_LABEL_MIN: 'Transação cancelada por falta de resposta, necessita revisão manual',
  OP_01010231_LABEL: 'Depósito com notas suspeitas rejeitado por tempo esgotado',
  OP_01010231_LABEL_MIN: 'Depósito com notas suspeitas rejeitado por tempo esgotado',
  OP_01010232_LABEL: 'Depósito com notas suspeitas',
  OP_01010232_LABEL_MIN: 'Depósito com notas suspeitas',
  OP_01010233_LABEL: 'Depósito com notas suspeitas com tempo esgotado',
  OP_01010233_LABEL_MIN: 'Depósito com notas suspeitas com tempo esgotado',
  OP_01010301_LABEL: 'Levantamento',
  OP_01010301_LABEL_MIN: 'Levantamento',
  OP_01010322_LABEL: 'Levantamento Cancelado',
  OP_01010322_LABEL_MIN: 'Lev. Cancelado',
  OP_01010328_LABEL: 'Levantamento rejeitado por erro',
  OP_01010328_LABEL_MIN: 'Levantamento R.',
  OP_01010334_LABEL: 'Levantamento Incompleto',
  OP_01010334_LABEL_MIN: 'Lev. Incompleto',
  OP_01010401_LABEL: 'Devolução',
  OP_01010401_LABEL_MIN: 'Devolução',
  OP_01011101_LABEL: 'Carregamento',
  OP_01011101_LABEL_MIN: 'Carregamento',
  OP_01011122_LABEL: 'Carregamento Cancelado',
  OP_01011122_LABEL_MIN: 'Carregamento C.',
  OP_01011123_LABEL: 'Carregamento Recuperado',
  OP_01011123_LABEL_MIN: 'Carreg. Recuperado',
  OP_01011128_LABEL: 'Carregamento Rejeitado por erro',
  OP_01011128_LABEL_MIN: 'Carre. R. por erro',
  OP_01011201_LABEL: 'Envio para cofre',
  OP_01011201_LABEL_MIN: 'Envio para cofre',
  OP_01011222_LABEL: 'Envio para cofre cancelado',
  OP_01011222_LABEL_MIN: 'Envio para cofre C.',
  OP_01011223_LABEL: ' Envio para cofre recuperado',
  OP_01011223_LABEL_MIN: 'Envio para cofre R.',
  OP_01011228_LABEL: 'Envio para cofre rejeitado por erro',
  OP_01011228_LABEL_MIN: 'Envio para cofre R.',
  OP_01010901_LABEL: 'Depósito Manual',
  OP_01010901_LABEL_MIN: 'Depósito Manual',
  OP_01011001_LABEL: 'Depósito Revertido',
  OP_01011001_LABEL_MIN: 'Depósito R.',
  OP_02120503_LABEL: 'Abertura de Período',
  OP_02120503_LABEL_MIN: 'Abertura de Período',
  OP_02120506_LABEL: 'Fecho de Período',
  OP_02120506_LABEL_MIN: 'Fecho de Período',
  OP_01011301_LABEL: 'Troco',
  OP_01011301_LABEL_MIN: 'Troco',
  OP_01011322_LABEL: 'Troco Cancelado',
  OP_01011322_LABEL_MIN: 'Troco Cancelado',
  OP_01011323_LABEL: 'Troco Recuperado',
  OP_01011323_LABEL_MIN: 'Troco Recuperado',
  OP_01011325_LABEL: 'Troco Incompleto',
  OP_01011325_LABEL_MIN: 'Troco Incompleto',
  OP_01011334_LABEL: 'Troco Incompleto',
  OP_01011334_LABEL_MIN: 'Troco Incompleto',
  OP_01011501_LABEL: 'Correção',
  OP_01011501_LABEL_MIN: 'Correção',
  OP_01011528_LABEL: 'Correção',
  OP_01011528_LABEL_MIN: 'Correção',
  OP_01011401_LABEL: 'Carregamento de produtos',
  OP_01011401_LABEL_MIN: 'Carregamento de produtos',
  OP_01012101_LABEL: 'Recolha cofre',
  OP_01012101_LABEL_MIN: 'Recolha cofre',
  OP_01012122_LABEL: 'Recolha C. Cancelado',
  OP_01012122_LABEL_MIN: 'Recolha Cofre Cancelado',
  OP_01010323_LABEL: 'Levantamento recuperado',
  OP_01010323_LABEL_MIN: 'Lev. recuperado',

  OP_1_LABEL: 'Pagamento',
  OP_1_LABEL_MIN: 'Pagamento',
  OP_2_LABEL: 'Autorização e compra',
  OP_2_LABEL_MIN: 'Autorização e compra',
  OP_3_LABEL: 'Autorização',
  OP_3_LABEL_MIN: 'Autorização',
  OP_4_LABEL: 'Reembolso',
  OP_4_LABEL_MIN: 'Reembolso',
  OP_5_LABEL: 'Carregamento de Hopper',
  OP_5_LABEL_MIN: 'Carregamento de Hopper',
  OP_6_LABEL: 'Auditoria de Hopper',
  OP_6_LABEL_MIN: 'Auditoria de Hopper',
  OP_7_LABEL: 'Seguro aberto',
  OP_7_LABEL_MIN: 'Seguro aberto',
  OP_8_LABEL: 'Depósito',
  OP_8_LABEL_MIN: 'Depósito',
  OP_9_LABEL: 'Abertura de período',
  OP_9_LABEL_MIN: 'Abertura de período',
  OP_10_LABEL: 'Fecho de período',
  OP_10_LABEL_MIN: 'Fecho de período',

  //Transactions status
  TRANSACTIONS_STATUS_WAITING: 'Em espera',
  TRANSACTIONS_STATUS_WILL_NOT_BE_SENT: 'Concluído',
  TRANSACTIONS_STATUS_SET_AS_NOT_TO_SEND: 'Concluído',
  TRANSACTIONS_STATUS_SENDED_TO_COREBANKING: 'Comunicado',
  TRANSACTIONS_STATUS_CARD_CHECKED: 'Cartão Aceite',
  TRANSACTIONS_STATUS_DEPOSIT_PARCIAL_RECEIVED: 'Parcial recebido',
  TRANSACTIONS_STATUS_WAITING_DECLARATION: 'A aguardar declaração',
  TRANSACTIONS_XLS_ERROR: 'Erro ao gerar ficheiro XLS',

  //APMs
  APM_TRANSACTIONS: 'Transações Pagamento Automático (MB)',
  APM_TRANSACTIONS_ACRONYM: 'Transações MB',
  APM_PERIODS: 'Períodos Pagamento Automático',
  APM_PERIODS_ACRONYM: 'Períodos MB',
  APM_CLOSE_PERIODS: 'Fecho de Períodos Pagamento Automático (MB)',
  APM_CLOSE_PERIODS_ACRONYM: 'Fecho de Períodos MB',
  APM_POS: 'Equipamentos Pagamento Automático (MB)',
  APM_POS_ACRONYM: 'Equipamentos MB',

  // HelpDesk
  HELPDESK_EQUIPMENTS: 'Equipamentos Helpdesk',
  HELPDESK_ENTITIES: 'Entidades Helpdesk',
  HELPDESK_TICKETS: 'Tickets Helpdesk',
  HELPDESK_CONTRACTS: 'Contractos Helpdesk',
  HELPDESK_MAINTENANCE_COMPANY: 'Empresa manutenção',
  HELPDESK_MAINTENANCE_AGENCY: 'Empresa agente',
  HELPDESK_CHOOSE_ENTITY: 'Escolher entidade',

  //entity
  HELPDESK_ADD_ENTITY: 'Adicionar entidade',
  HELPDESK_ENTITY_REMOVE: 'Tem a certeza que quer apagar esta entidade?',
  ENTITY_TYPE_0: 'Empresa',
  ENTITY_TYPE_1: 'Agente',
  ENTITY_TYPE_2: 'Fornecedor',
  ENTITY_TYPE_3: 'Prestador serv. manutenção',
  ENTITY_TYPE_NULL: 'Todas',
  ENTITY_EXTERNAL_DATA: 'Dados externos',
  ENTITY_AUTO_ENTID: 'Atribuição automática',
  ENTITY_NEW_ENTITY: 'Nova entidade',
  ENTITY_ID: 'ID Entidade',
  ENTITY_NOT_DEFINED: 'Entidade não definida',

  //edit Entity
  EDIT_ENTITY_FORM_LABEL_GID: 'Grupo (GID)',
  EDIT_ENTITY_FORM_LABEL_LOGO: 'Logotipo',
  EDIT_ENTITY_FORM_LABEL_USESHIFTS: 'Shifts',
  EDIT_ENTITY_FORM_LABEL_PRINTTYPE: 'Tipo de Impressão',
  EDIT_ENTITY_FORM_LABEL_REPORTTYPE: 'Tipo de Relatório',
  EDIT_ENTITY_FORM_LABEL_SIBSMERCHANTCODE: 'Sibs Mech. Code',
  EDIT_ENTITY_FORM_LABEL_BILLINGENTITY: 'Entidade de cobrança',
  EDIT_ENTITY_FORM_LABEL_OWNERID: 'Owner ID',
  EDIT_ENTITY_FORM_LABEL_ACTIVITY: 'Ramo de atividade',
  EDIT_ENTITY_FORM_LABEL_BILLVOLUME: 'Volume faturação',
  EDIT_ENTITY_LABEL_READ: 'Visualizar Entidade',
  EDIT_ENTITY_LABEL_EDIT: 'Edição de Entidade',
  EDIT_ENTITY_FORM_LABEL_ACTIVITY_NOT_DEFINED: 'Não Definida',
  EDIT_ENTITY_CONTROLLER_ALERT_DELETE_CONFIRM: 'Tem a certeza que quer apagar a entidade',
  EDIT_ENTITY_CONTROLLER_ALERT_DELETE_SUCCESS: 'Entidade eliminada com successo',

  //ticket
  HELPDESK_ADD_TICKET: 'Adicionar Ticket',
  HELPDESK_TICKET_STATUS_0: 'Aberto',
  HELPDESK_TICKET_STATUS_1: 'Fechado',
  HELPDESK_TICKET_STATUS_2: 'Reabrir',
  HELPDESK_TICKET_STATUS_3: 'Discussão',
  HELPDESK_TICKET_STATUS_4: 'Esclarecimento',
  HELPDESK_TICKET_STATUS_5: 'Criar IR',
  HELPDESK_TICKET_STATUS_6: 'IR fechado',
  HELPDESK_TICKETS_URGENCY_0: 'Imediata',
  HELPDESK_TICKETS_URGENCY_1: 'Alta',
  HELPDESK_TICKETS_URGENCY_2: 'Média',
  HELPDESK_TICKETS_URGENCY_3: 'Baixa',
  HELPDESK_TICKETS_URGENCY_4: 'Nenhuma',
  HELPDESK_TICKET_CLASSIFICATION_0: 'Erro',
  HELPDESK_TICKET_CLASSIFICATION_1: 'Troco',
  HELPDESK_TICKET_CLASSIFICATION_2: 'Erro externo',
  HELPDESK_TICKET_CLASSIFICATION_3: 'Problema',
  HELPDESK_TICKET_STATUS: 'Estado',
  HELPDESK_TICKET_OPEN_DT: 'Data de abertura',

  //classifications
  HELPDESK_TICKET_MANAGE: 'Gerir',
  HELPDESK_TICKET_LIST: 'lista',
  HELPDESK_TICKET_FAULT: 'Falha',
  HELPDESK_TICKET_CAUSE: 'Causa',
  HELPDESK_TICKET_ACTION: 'Resolução',
  HELPDESK_TICKET_FAULTS: 'Falhas',
  HELPDESK_TICKET_CAUSES: 'Causas',
  HELPDESK_TICKET_ACTIONS: 'Resoluções',
  HELPDESK_TICKET_MANAGE_CLASSIFICATION: 'Gerir classificação do ticket',

  //edit ticket
  HELPDESK_TICKET_UPDATE_COMMUNICATION_CHANNEL: 'Canal de comunicação',
  HELPDESK_TICKET_UPDATE_ISSUE_TYPES: 'Tipo de problema',
  HELPDESK_TICKET_UPDATE_CHANGE_REQUEST: 'Solicitação de alteração',
  HELPDESK_TICKET_UPDATE_INFORMATION_REQUEST: 'Solicitação de informações',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_PROBLEM: 'Problema reportado',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_FAULT: 'Falha detetada',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_CAUSE: 'Causa da falha',
  HELPDESK_TICKET_UPDATE_CLASSIFICATION_ACTION: 'Acção de resolução',
  HELPDESK_TICKET_UPDATE_LAST_UPDATE: 'Última actualização',
  HELPDESK_TICKET_UPDATE_LAST_STATUS: 'Último estado',
  HELPDESK_TICKET_UPDATE_INT_TYPE: 'Tipo interv.',
  HELPDESK_TICKET_UPDATE_INT_TYPE_REMOTE: 'Remoto',
  HELPDESK_TICKET_UPDATE_INT_TYPE_LOCAL: 'Local',
  HELPDESK_EDIT_TICKET_MODAL_TITLE: 'Editar ticket / Detalhes',
  HELPDESK_NEW_TICKET_MODAL_TITLE: 'Nova linha de status',
  HELPDESK_EDIT_TICKET_ALERT_UPDATED_SUCCESS: 'Ticket editado',
  HELPDESK_EDIT_TICKET_ALERT_UPDATED_ERROR: 'Erro ao editar ticket',
  HELPDESK_TICKET_ADD_LINE: 'Actualizar estado',
  HELPDESK_ADD_LINE_ALERT_UPDATED_SUCCESS: 'Linha adicionada',
  HELPDESK_ADD_LINE_ALERT_UPDATED_ERROR: 'Erro ao adicionar linha',

  //Helpdesk Contracts
  HELPDESK_CONTRACTS_LABEL: 'Contratos',
  HELPDESK_CONTRACTS_ID: 'Id Contrato',
  HELPDESK_CONTRACTS_CREATEDATE: 'Criação',
  HELPDESK_CONTRACTS_VALUE: 'Valor',
  HELPDESK_CONTRACTS_STATE: 'Estado Contrato',
  HELPDESK_CONTRACTS_RENEWDATE: 'Renovação',
  HELPDESK_CONTRACTS_EDIT: 'Editar Contrato',
  HELPDESK_CONTRACTS_COPY: 'Copiar Contrato',
  HELPDESK_ADD_CONTRACTS: 'Adicionar Contrato',
  HELPDESK_AGREEMENT_NUML: 'Número do Contrato',
  HELPDESK_AGREEMENT_ENTID: 'Entid',
  HELPDESK_EQUIPMENT_TYPE: 'Tipo de Equipamento',
  HELPDESK_LABOR: 'Mão de Obra',
  HELPDESK_FIRST_LINE: 'Primeira Linha',
  HELPDESK_SECOND_LINE: 'Segunda Linha',
  HELPDESK_HARDWARE: 'Peças',
  HELPDESK_PROCESSING_SERVICE: 'Serviço de Processamento',
  HELPDESK_NEW_SOFTWARE_RELEASES: 'Novos Lançamentos de Software',
  HELPDESK_REPLACEMENT_PARTS: 'Garantia de 24 Horas para Peças de Reposição',
  HELPDESK_ACCESS_PLATFORM: 'Acesso à Plataforma Web',
  HELPDESK_DATE: 'Data',
  HELPDESK_VALUE: 'Valor',
  HELPDESK_CONTRACT_YEARS: 'Anos do Contrato',
  HELPDESK_CANCELLATION_DATE: 'Data de Cancelamento',
  HELPDESK_LAST_RENEW_DATE: 'Data da Última Renovação',
  HELPDESK_REV_TYPE: 'Tipo de Revisão',
  HELPDESK_REV_VALUE: 'Valor da Renovação',
  HELPDESK_RENOV_DATE: 'Data de Renovação',
  HELPDESK_NEXT_RENOV_DATE: 'Data Próxima Renovação',
  HELPDESK_LAST_INVOICE_DATE: 'Data da Última Fatura',
  HELPDESK_INVOICE_STATE: 'Estado da Fatura',
  HELPDESK_BILLING_PERIOD: 'Período de Faturamento',
  HELPDESK_NEXT_INVOICE_DATE: 'Próxima Data da Fatura',
  HELPDESK_CONTRACT_STATE: 'Estado do Contrato',
  HELPDESK_SLA_CODE: 'Código SLA',
  HELPDESK_CONTRACT_NUMBER: 'Número de Contrato',
  EDIT_AGREEMENT_CONTROLLER_ALERT_ADD_SUCCESS: 'Contrato adicionado com successo',
  EDIT_AGREEMENT_CONTROLLER_ALERT_ADD_ERROR: 'Erro ao adicionar contrato',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_SUCCESS: 'Contrato eliminado com successo',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_ERROR: 'Erro ao eliminado contrato',
  EDIT_AGREEMENT_CONTROLLER_ALERT_EDIT_SUCCESS: 'Contrato editado com successo',
  EDIT_AGREEMENT_CONTROLLER_ALERT_EDIT_ERROR: 'Erro ao editar contrato',
  EDIT_AGREEMENT_CONTROLLER_ALERT_DELETE_CONFIRM: 'Tem a certeza que quer apagar o contrato',
  EDIT_AGREETYPE_CONTROLLER_ALERT_ADD_SUCCESS: 'Tipo de contrato adicionado com successo',
  EDIT_AGREETYPE_CONTROLLER_ALERT_ADD_ERROR: 'Erro ao eliminar tipo de contrato',
  EDIT_AGREETYPE_CONTROLLER_ALERT_DELETE_SUCCESS: 'Tipo de contrato eliminado com successo',
  EDIT_AGREETYPE_CONTROLLER_ALERT_DELETE_ERROR: 'Erro ao eliminar tipo de contrato',
  EDIT_AGREETYPE_CONTROLLER_ALERT_EDIT_SUCCESS: 'Tipo de contrato editado com successo',
  EDIT_AGREETYPE_CONTROLLER_ALERT_EDIT_ERROR: 'Erro ao editar tipo de contrato',

  //Contract rev type
  HELPDESK_CONTRACT_REV_TYPE_1: 'n/d',
  HELPDESK_CONTRACT_REV_TYPE_2: 'Valor fixo',
  HELPDESK_CONTRACT_REV_TYPE_3: 'Valor publicado',

  // Contract invoice state
  HELPDESK_CONTRACT_INVOICE_STATE_1: 'n/d',
  HELPDESK_CONTRACT_INVOICE_STATE_2: 'Liquidada',
  HELPDESK_CONTRACT_INVOICE_STATE_3: 'Por liquidar',

  //Contract billing period
  HELPDESK_CONTRACT_BILLING_PERIOD_1: 'n/d',
  HELPDESK_CONTRACT_BILLING_PERIOD_2: 'Mensal',
  HELPDESK_CONTRACT_BILLING_PERIOD_3: 'Trimestral',
  HELPDESK_CONTRACT_BILLING_PERIOD_4: 'Semestral',
  HELPDESK_CONTRACT_BILLING_PERIOD_5: 'Anual',

  // Contract state
  HELPDESK_CONTRACT_STATE_1: 'n/d',
  HELPDESK_CONTRACT_STATE_2: 'Activo',
  HELPDESK_CONTRACT_STATE_3: 'Pendente',
  HELPDESK_CONTRACT_STATE_4: 'Cancelado',
  HELPDESK_CONTRACT_STATE_5: 'Não conformado',

  //Distribuitions
  DISTRIBUITIONS_ADD_BUTTON: 'Adicionar',
  DISTRIBUITIONS_LIST: 'Listas',
  ADD_DISTRIBUITION_SUCCESS: 'Lista adicionada',
  ADD_DISTRIBUITION_ERROR: 'Erro ao aidionar lista',
  EDIT_DISTRIBUITION_SUCCESS: 'Lista editada',
  EDIT_DISTRIBUITION_ERROR: 'Erro ao editar lista',
  DELETE_DISTRIBUITION_SUCCESS: 'Lista apagada',
  DELETE_DISTRIBUITION_ERROR: 'Erro ao apagar lista',

  //AType
  CLIENT_CARD_INSERTED: 'Cartão de cliente inserido',
  NON_READABLE_CARD: 'Cartão ilegível',
  READABLE_CARD: 'Cartão legível',
  GENERATED_NEW_TRANSACTION_KEY: 'Nova chave de transação gerada',
  CHECK_OPERATION_REQUESTED: 'Verifique a operação solicitada',
  CLIENT_CARD_RETURNED: 'Cartão de cliente devolvido a cliente',
  CLIENT_CARD_REMOVED: 'Cartão de cliente removido pelo cliente',
  CHECK_OPERATION_GOOD_RESPONSE: ' Verifique resposta positiva da operação',
  CHECK_OPERATION_ERROR: 'Verifique erro na operação',
  CLIENT_ACCOUNT_SELECTED: 'Conta de cliente selecionada',
  CLIENT_ACCOUNT_INSERTED: 'Conta inserida',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_REQUESTED: 'Verifique operação de conta solicitada',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_GOOD_RESPONSE: 'Verifique resposta positiva de operação de conta',
  CHECK_EXTERNAL_ACCOUNT_OPERATION_ERROR: 'Check Account operation error',
  CLIENT_CANCEL: 'Cliente cancelou',
  CLIENT_CHOOSE_OR_INSERT_DEPOSIT_REASON: 'Motivo de depósito selecionado ou inserido',
  ENABLED_BANKNOTES_VALIDATOR: 'Validador de notas ativado',
  CLIENT_ACCEPTS_BANKNOTES_COUNT: 'Cliente aceitou contagem de notas',
  CLIENT_REJECT_BAKNOTES_COUNT: 'Cliente rejeitou contagem de notas',
  DECLARATION_AMOUNT_REACHED: 'Montante declarado atingido',
  DECLARATION_SELECTED: 'Declaração selecionada',
  DEPOSIT_OPERATION_REQUESTED: 'Operação de depósito solicitada',
  DEPOSIT_OPERATION_GOOD_RESPONSE: 'Resposta positiva operação de depósito',
  DEPOSIT_OPERATION_ERROR: 'Erro operação depósito',
  BANKNOTES_SENT_TO_SAFE: 'Notas enviadas para o cofre',
  BANKNOTES_DELIVERED_TO_CLIENT: 'Notas entregues ao cliente',
  RECEIPT_PRINTED: 'Recibo impresso',
  GOOD_USER_IDENTIFICATION: 'Identificação de utilizador positiva',
  BAD_USER_IDENTIFICATION: 'Identificação de utilizador negativa',
  PERIOD_CLOSE_OPERATION: 'Operação fecho de período',
  PERIOD_DATA_SAVED: 'Dados de período guardados',
  SAFE_DOOR_OPENED: 'Porta do cofre aberta',
  BAG_REMOVED: 'Saco de notas removido',
  BAG_INSERTED: 'Saco de notas inserido',
  SAFE_DOOR_CLOSED: 'Porta do cofre fechada',
  NEW_PERIOD_OPEN: 'Novo período aberto',
  CASH_BALANCE: 'Saldo de caixa',
  EJECT_CARD: 'Cartão ejetado',
  LAST_PERIOD_REPORT: 'Relatório da operação do último período',
  SHUTDOWN: 'Desligar',
  RESTART: 'Reiniciar',
  UNLOCK_ESCROW: 'Desbloquear escrow',
  IN_SERVICE: 'Em serviço',
  OPEN_ESCROW: 'Abrir escrow',
  CLOSE_ESCROW: 'Fechar escrow',
  VPN_CONNECT: 'Conectar VPN',
  VPN_DISCONNECT: 'Desconectar VPN',
  CLIENT_CARD_NOT_REMOVED: 'Cartão de cliente não removido',
  MINIMUM_AMOUNT_REACHED: 'Montante mínimo atingido',
  MAXIMUM_AMOUNT_REACHED: 'Montante máximo atingido',
  SHUTDOWN_BY_UPS_ON_BATTERY: 'Desligado pela UPS a funcionar com bateria',
  REMOTE_SHUTDOWN: 'Desligamento remoto',
  REMOTE_RESTART: 'Reinício remoto',
  REMOTE_UNLOCK_ESCROW: 'Desbloqueio remoto do escrow',
  LOCAL_UNLOCK_ESCROW: 'Desbloqueio local do escrow',
  MANUAL_OUT_OF_SERVICE_REMOVED: 'Fora de serviço manual removido',
  CENTRAL_OUT_OF_SERVICE: 'Fora de serviço central',
  LOCAL_CLOSE_ESCROW: 'Fecho do escrow local',
  LOCAL_OPEN_ESCROW: 'Abertura local do escrow local',
  REMOTE_CLOSE_ESCROW: 'Fecho de escrow remoto',
  REMOTE_OPEN_ESCROW: 'Abertura de escrow remoto',
  INVALID_ESCROW_MOVEMENT: 'Movimento de escrow inválido',
  ESCROW_NOT_EMPTY_DETECTED: 'Detetado que o escrow não está vazio',
  INVALID_ACCOUNTS: 'Contas inválidas',
  EXISTENT_CARD: 'Cartão existente',
  WRONG_PIN: 'PIN Errado',
  WRONG_PIN_3RD_ATTEMPT: 'PIN errado depois de 3 tentativas',
  VALID_PIN: 'PIN do utilizador válido',
  NONEXISTENT_CARD: 'Cartão inexistente',
  BANKNOTES_VALIDATOR_ERROR: 'Erro no validador de notas',
  FAKE_NOTES_DETECTED: 'Notas falsas detetadas',
  FAKE_NOTES_DETECTED_CLEARED: 'Notas falsas detectadas limpas',
  NONEXISTENT_USER: 'Utilizador inexistente',
  EXISTENT_USER: 'Utilizador existente',
  REJECT_BLOCKER_ENABLE: 'Bloqueador de rejeições activado',
  REJECT_BLOCKER_DISABLE: 'Bloqueador de rejeições desativado',
  FAKE_NOTES_DETECTED_CLEARED_LOCALLY: 'Notas falsas detectadas limpas localmente',

  //server:
  ATYPE_USER_INSERTED: 'Utilizador inserido',
  ATYPE_USER_DELETED: 'Utilizador apagado',
  ATYPE_USER_UPDATED: 'Utilizador atualizado',
  ATYPE_EQUIPMENT_INSERTED: 'Equipamento inserido',
  ATYPE_EQUIPMENT_DELETED: 'Equipamento apagado',
  ATYPE_EQUIPMENT_UPDATED: 'Equipamento atualizado',
  ATYPE_OPERATION_RESTART_REQUESTED: 'Operação de reinício solicitada',
  ATYPE_OPERATION_RESTART_SENT_TO_EQUIPMENT: 'Operação de reinício enviada para o equipamento',
  ATYPE_OPERATION_RESTART_EXPIRED: 'Operação de reinício expirada',
  ATYPE_OPERATION_SHUTDOWN_REQUESTED: 'Operação de desligamento solicitada',
  ATYPE_OPERATION_SHUTDOWN_SENT_TO_EQUIPMENT: 'Operação de desligamento enviada para o equipamento',
  ATYPE_OPERATION_SHUTDOWN_EXPIRED: 'Operação de desligamento expirada',
  ATYPE_OPERATION_UNLOCK_ESCROW_REQUESTED: 'Operação de desbloqueio do escrow solicitada',
  ATYPE_OPERATION_UNLOCK_ESCROW_SENT_TO_EQUIPMENT: 'Operação desloqueio do escrow enviada para o equipamento',
  ATYPE_OPERATION_UNLOCK_ESCROW_EXPIRED: 'Operação desbloqueio do escrow expirada',
  ATYPE_OPERATION_OUT_OF_SERVICE_REQUESTED: 'Operação fora de serviço solicitada',
  ATYPE_OPERATION_OUT_OF_SERVICE_SENT_TO_EQUIPMENT: 'Operação fora de serviço enviada para o equipamento',
  ATYPE_OPERATION_OUT_OF_SERVICE_EXPIRED: 'Operação fora de serviço expirou',
  ATYPE_OPERATION_IN_SERVICE_REQUESTED: 'Operação pôr em serviço solicitada',
  ATYPE_OPERATION_IN_SERVICE_SENT_TO_EQUIPMENT: 'Operação pôr em serviço enviada para o equipamento',
  ATYPE_OPERATION_IN_SERVICE_EXPIRED: 'Operação pôr em serviço expirou',
  ATYPE_OPERATION_OPEN_ESCROW_REQUESTED: 'Operação abertura do escrow solicitada',
  ATYPE_OPERATION_OPEN_ESCROW_SENT_TO_EQUIPMENT: 'Operação abertura do escrow enviada para o equipamento',
  ATYPE_OPERATION_OPEN_ESCROW_EXPIRED: 'Operação abertura do escrow expirou',
  ATYPE_OPERATION_CLOSE_ESCROW_REQUESTED: 'Operação fecho do escrow solicitada',
  ATYPE_OPERATION_CLOSE_ESCROW_SENT_TO_EQUIPMENT: 'Operação fecho do escrow enviada para o equipamento',
  ATYPE_OPERATION_CLOSE_ESCROW_EXPIRED: 'Operação fecho do escrow expirada',
  ATYPE_OPERATION_VPN_CONNECT: 'Operação conectar a vpn solicitada',
  ATYPE_OPERATION_VPN_DISCONNECT: 'Operação desconectar vpn solicitada',
  ATYPE_OPERATION_VPN_EXPIRED: 'Operação conectar/desconectar vpn expirou',
  ATYPE_OPERATION_VPN_SENT_TO_EQUIPMENT: 'Operação vpn enviada para o equipamento',
  ATYPE_ENTITY_INSERTED: 'Entidade inserida',
  ATYPE_ENTITY_DELETED: 'Entidade apagada',
  ATYPE_ENTITY_UPDATED: 'Entidade atualizada',
  ATYPE_LOCATION_INSERTED: 'Local inserido',
  ATYPE_LOCATION_DELETED: 'Local apagado',
  ATYPE_LOCATION_UPDATED: 'Local atualizado',
  ATYPE_CURRENCY_INSERTED: 'Divisa inserida',
  ATYPE_CURRENCY_DELETED: 'Divisa apagada',
  ATYPE_CURRENCY_UPDATED: 'Divisa atualizada',
  ATYPE_OPERATION_IGNORED: 'Operação ignorada pelo equipamento devido a tipo de operação desconhecido pelo equipamento',
  ATYPE_PRODUCT_EDITED: 'Produto editado',
  ATYPE_PRODUCT_DISPENSER_EDITED: 'Dispensador de produto editado',
  ATYPE_UPDATE_USER_BALANCE: 'Atualização saldo de utilizador',
  ATYPE_ERROR: 'Audit Type não reconhecido',

  //Helpdesk Devices
  HELPDESK_PRODUCT_CODE: 'Código Produto',

  //Helpdesk Product Management
  PRODUCT_MANAGEMENT: 'Gestão de Produtos',
  PRODUCT_MANAGEMENT_SMALL: 'Gest. Produ.',
  PRICE_REFERENCE: 'Referência de preço',
  LAST_SUPPLIER: 'Último fornecedor',
  LAST_PRICE: 'Último preço',
  AVERAGE_DELIVERY_TIME: 'Tempo estimado de entrega',
  AVERAGE_DELIVERY_TIME_MIN: 'Tempo est. entrega',
  CE_CERTIFICATE: 'Certificado CE',
  CB_CERTIFICATE: 'Certificado CB',
  PRODUCT_ADD_PRODUCT: 'Adicionar Produto',
  PRODUCT_DEV_TYPE: 'Tipo Equipamento',
  ADD_PRODUCT_SUCCESS: 'Produto adicionado',
  EDIT_PRODUCT_SUCCESS: 'Produto atualizado',
  DELETE_PRODUCT_SUCCESS: 'Product eliminado',
  ADD_PRODUCT_ERROR: 'Erro a adicionar produto',
  EDIT_PRODUCT_ERROR: 'Erro a atualizar produto',
  DELETE_PRODUCT_ERROR: 'Erro a eliminar produto',

  //Sync commands
  SYNC_COMMANDS_DELETE_SUCCESS: 'Comando de sincronização eliminado',
  SYNC_COMMANDS_DELETE_ERROR: 'Erro ao eliminar comando de sincronização',
  SYNC_COMMANDS_ADD_SUCCESS: 'Comando de sincronização adicionado',
  SYNC_COMMANDS_ADD_ERROR: 'Erro ao adicionar comando de sincronização',

  //User shift
  USER_SHIFT_AMOUNT_RECEIVED: 'Montante recebido',
  USER_SHIFT_TITLE: 'Turnos',
  USER_SHIFTS_METHODS_CARD: 'Cartão (MB)',
  USER_SHIFTS_METHODS_CASH: 'Numerário',
  USER_SHIFTS_REPORT_ERROR: 'Erro ao obter o relatório',

  //Brisa Users Summaries
  BRISA_USERS_SUMMARIES_TITLE: 'Resumo por utilizador',
  BRISA_USERS_SUMMARIES_ID: 'ID',
  BRISA_USERS_SUMMARIES_USER_ID: 'ID Utilizador',
  BRISA_USERS_SUMMARIES_NAME: 'Nome',
  BRISA_USERS_SUMMARIES_USER_NAME: 'Nome do utilizador',
  BRISA_USERS_SUMMARIES_LAST_OPER: 'Última operação',
  BRISA_USERS_SUMMARIES_EID_LAST_OPER: 'EID (última oper.)',
  BRISA_USERS_SUMMARIES_DATE_LAST_OPER: 'Data (última oper.)',
  BRISA_USERS_SUMMARIES_AMOUNT_LAST_OPER: 'Montante (última oper.)',
  BRISA_USERS_SUMMARIES_AMOUNT_ADD: 'Montante a adicionar (+/-)',
  BRISA_USERS_SUMMARIES_BALANCE: 'Saldo',
  BRISA_USERS_SUMMARIES_WITH_BALANCE: 'Com saldo',
  BRISA_USERS_SUMMARIES_CURRENT_BALANCE: 'Saldo atual',
  BRISA_USERS_SUMMARIES_BALANCE_ZERO: 'Saldo a 0 (zero)',
  BRISA_USERS_SUMMARIES_MENU_FIX_BALANCE: 'Correção saldo',
  BRISA_USERS_SUMMARIES_MENU_FIX_TRANSACTIONS: 'Transações',
  BRISA_USER_SUMMARY_EDIT: 'Editar resumo de utilizador',
  BRISA_USER_SUMMARY_EDIT_SUCCESS: 'Pedido registado com sucesso, será enviado ao equipamento para processamento',
  BRISA_USER_SUMMARY_EDIT_ERROR: 'Erro ao editar resumo de utilizador',
  BRISA_USER_SUMMARY_ADD: 'Adicionar resumo de utilizador',
  BRISA_USER_SUMMARY_ADD_SUCCESS: 'Resumo de utilizador adicionado',
  BRISA_USER_SUMMARY_ADD_ERROR: 'Erro ao adicionar resumo de utilizador',
  BRISA_USER_SUMMARY_DELETE_SUCCESS: 'Resumo de utilizador removido',
  BRISA_USER_SUMMARY_DELETE_ERROR: 'Erro ao remover resumo de utilizador',

  //Brisa Withdraw sets
  BRISA_WITHDRAW_SETS_TITLE: 'Conjuntos de levantamento',
  BRISA_WITHDRAW_SETS_ENTITY: 'Entidade',
  BRISA_WITHDRAW_SETS_ID: 'ID',
  BRISA_WITHDRAW_SETS_DESCRIPTION: 'Descrição',
  BRISA_WITHDRAW_SETS_AMOUNT: 'Valor',
  BRISA_WITHDRAW_SETS_TYPE: 'Tipo',
  BRISA_WITHDRAW_SETS_QUANTITY: 'Quantidade',
  BRISA_WITHDRAW_SETS_EDIT: 'Editar levantamento',
  BRISA_WITHDRAW_SETS_EDIT_SUCCESS: 'Levantamento atualizado',
  BRISA_WITHDRAW_SETS_EDIT_ERROR: 'Falha ao atualizar o levantamento',
  BRISA_WITHDRAW_SETS_ADD: 'Adicionar levantamento',
  BRISA_WITHDRAW_SETS_ADD_SUCCESS: 'Levantamento adicionado',
  BRISA_WITHDRAW_SETS_ADD_ERROR: 'Falha ao adicionar o levantamento',
  BRISA_WITHDRAW_SETS_DELETE_SUCCESS: 'Levantamento eliminado ',
  BRISA_WITHDRAW_SETS_DELETE_ERROR: 'Falha ao eliminar o levantamento'
};
